import { memo, useEffect, useState } from 'react'

import s from './MainSliderCatalog.module.scss'
import { cowsChapterList } from '@/assets/data/slider-chapters'
import TestingSliderCatalog from '@/shared/Slider/TestingCatalogSlider/TestingSliderCatalog'
import { SliderSettings } from '@/types'
import SliderSection from '@/widgets/SliderSection/SliderSection'

interface IMainSliderCatalogProps {
    list: any
    zIndex?: number
    type?: string
    settings?: SliderSettings[]
    lightTheme?: boolean
    data?: {
        title?: string
        description?: string
        buttonText?: string
        buttonLink?: string
    }
}

export const MainSliderCatalog = memo(({ list, zIndex, type, settings, data, lightTheme }: IMainSliderCatalogProps) => {
    const [currentChapter, setCurrentChapter] = useState<number | undefined>(undefined)
    const [currentList, setCurrentList] = useState(cowsChapterList)

    useEffect(() => {
        if (type === 'useful-materials') {
            if (list && list.length > 0) {
                setCurrentList(list)
            }
        } else {
            if (list && list.length > 0) {
                if (currentChapter === undefined) {
                    let newArr = []
                    list.forEach(el => {
                        newArr.push(...(el.animal_types_category ?? []).map(e => e))
                    })
                    setCurrentList(newArr)
                } else {
                    setCurrentList(list[currentChapter]?.animal_types_category ?? [])
                }
            }
        }
    }, [list, type, currentChapter])

    return (
        <section
            className={'container ' + s.wrapper}
        >
            <SliderSection
                title={data.title}
                description={data.description}
                buttonText={data.buttonText}
                buttonLink={data.buttonLink}
                lightTheme={lightTheme}
            />
            <div style={{ position: 'relative', overflow: 'visible' }}>
                <TestingSliderCatalog
                    type={type}
                    list={currentList}
                    zIndex={zIndex ? zIndex : undefined}
                    linkedCards={true}
                    settings={settings}
                    lightTheme={lightTheme}
                />
            </div>
        </section>
    )
})
